/**
 * V1 exports for the SVM mechanism
 */
export { ExactSvmSchemeV1 } from "../exact/v1";

export const NETWORKS: string[] = ["solana", "solana-devnet", "solana-testnet"];
